import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import usePageTracking from './lib/usePageTracking';
import { UserProvider } from './UserContext';
import { ApiProvider } from './ApiContext';
import NewOrExistingCustomerScreen from './screens/NewOrExistingCustomerScreen';
import EnterZipCodeScreen from './screens/EnterZipCodeScreen';
import ChooseServiceScreen from './screens/ChooseServiceScreen';
import SelectDayScreen from './screens/SelectDayScreen';
import ChooseTimeSlotScreen from './screens/ChooseTimeSlotScreen';
import EnterEmailScreen from './screens/EnterEmailScreen';
import CreatePasswordScreen from './screens/CreatePasswordScreen';
import PersonalInfoScreen from './screens/PersonalInfoScreen';
import PersonalAddressScreen from './screens/PersonalAddressScreen';
import BillingAddressScreen from './screens/BillingAddressScreen';
import AddPaymentCardScreen from './screens/AddPaymentCardScreen';
import AddPaymentCardScreenA from './screens/AddPaymentCardScreenA';
import ConfirmAppointmentScreen from './screens/ConfirmAppointmentScreen';
import AppointmentBookedScreen from './screens/AppointmentBookedScreen';
import { submitForm } from './mockApi';
import apiClient from './apiClient';

const api = { submitForm: submitForm, client: apiClient };

const App: React.FC = () => {
  return (
    <UserProvider>
      <ApiProvider api={api}>
        <Router>
          <AppRoutes />
        </Router>
      </ApiProvider>
    </UserProvider>
  );
};

const AppRoutes = () => {
  usePageTracking();
  return (
    <Routes>
      <Route path="/" element={<NewOrExistingCustomerScreen />} />
      <Route path="/enter-zipcode" element={<EnterZipCodeScreen />} />
      <Route path="/choose-service" element={<ChooseServiceScreen />} />
      <Route path="/choose-day" element={<SelectDayScreen />} />
      <Route path="/choose-time-slot" element={<ChooseTimeSlotScreen />} />
      <Route path="/enter-email" element={<EnterEmailScreen />} />
      <Route path="/create-password" element={<CreatePasswordScreen />} />
      <Route path="/personal-info" element={<PersonalInfoScreen />} />
      <Route path="/personal-address" element={<PersonalAddressScreen />} />
      <Route path="/billing-address" element={<BillingAddressScreen />} />
      <Route path="/add-payment-card" element={<AddPaymentCardScreen />} />
      <Route path="/add-payment-card-a" element={<AddPaymentCardScreenA />} />
      <Route path="/confirm-appointment" element={<ConfirmAppointmentScreen />} />
      <Route path="/appointment-booked" element={<AppointmentBookedScreen />} />
    </Routes>
  );
};

export default App;
